'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _constants = require('../../constants');
var _jidParser = require('../../helpers/jidParser');
var _timeDeltaHelper = require('../../helpers/timeDeltaHelper');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/* eslint-disable */
var botTexts = {
  EXCHANGE: 'Dica de amigo! Anuncie o que você quer trocar e deixe a mágica acontecer 😉'
};
var tipTexts = {
  ADVANCE_PAYMENT: 'Só aceite pagamento antecipado ou envio do produto caso esteja usando a OLX Pay.',
  PHONE_EMAIL: 'Para sua segurança, não compartilhe seu e-mail e número de telefone. Acompanhe tudo pelo chat e desconfie de comprovantes de pagamento ou links por e-mail, podem ser falsos.',
  EXTERNAL_LINK: 'Verifique a origem do link antes de clicá-lo.',
  MEETING: 'Marque seus encontros em locais públicos movimentados, como shoppings e saídas de metrô.',
  PRIVATE_DATA: 'Fique ligado ao compartilhar documentos, informações pessoais ou financeiras.',
  VALIDATION_CODE_FRAUD: 'Para proteção da sua conta, nunca compartilhe com ninguém o código enviado via SMS para você. Nunca pedimos códigos de confirmação via chat.'
  /* eslint-enable */
};
var MessageParser = function (_Plugin) {
  _inherits(MessageParser, _Plugin);
  function MessageParser() {
    _classCallCheck(this, MessageParser);
    return _possibleConstructorReturn(this, (MessageParser.__proto__ || Object.getPrototypeOf(MessageParser)).apply(this, arguments));
  }
  _createClass(MessageParser, [{
    key: 'fromWebsocket',
    value: function fromWebsocket(message) {
      var id = message.attrs.id;
      if (id === 'security_message') {
        return this.fromRoom(message, 'security_message');
      }
      var event = message.getChild('event');
      if (event) {
        return this.fromEvent(event);
      }
      var result = message.getChild('result');
      if (result) {
        return this.fromDB(result);
      }
      return this.fromRoom(message, 'real-time');
    }
  }, {
    key: 'fromEvent',
    value: function fromEvent(event) {
      var message = event.getChild('items').getChild('item').getChild('message');
      return this.fromRoom(message, 'real-time');
    }
  }, {
    key: 'fromDB',
    value: function fromDB(result) {
      var message = result.getChild('forwarded').getChild('message');
      return this.fromRoom(message, 'db');
    }
  }, {
    key: 'fromRoom',
    value: function fromRoom(message, source) {
      var _message$attrs = message.attrs,
        id = _message$attrs.id,
        roomnameJid = _message$attrs.from,
        type = _message$attrs.type,
        to = _message$attrs.to;
      var _decodeJid = (0, _jidParser.decodeJid)(roomnameJid),
        host = _decodeJid.host,
        user = _decodeJid.user,
        senderFromRoomname = _decodeJid.resource;
      var sender = senderFromRoomname;
      if (!senderFromRoomname && source !== 'security_message') {
        var _decodeJid2 = (0, _jidParser.decodeJid)(to),
          senderFromTo = _decodeJid2.user;
        sender = senderFromTo;
      }
      var archived = message.getChild('archived');
      var _ref = archived ? archived.attrs : {},
        timestamp = _ref.id;
      var threadText = message.getChildText('thread');
      var thread = threadText ? JSON.parse(threadText) : {};
      var subject = message.getChildText('subject');
      var originalTimestamp = timestamp || thread.customTimestamp;
      var timestampWithDelta = (0, _timeDeltaHelper.applyTimestampDelta)(originalTimestamp, this.entity.timestampDelta);
      var body = message.getChildText('body');
      var parsedMessage = {
        id: id,
        roomname: (0, _jidParser.encodeJid)({
          host: host,
          user: user
        }),
        text: body,
        status: this._translateStatus(type, thread),
        timestamp: timestampWithDelta,
        originalTimestamp: originalTimestamp,
        sender: String(sender),
        customType: thread.customType || 'normal',
        notificationData: thread.notificationData || {},
        version: subject === 'v2' ? 2 : 1,
        source: source,
        extensions: thread.extensions || []
      };
      var parsedMessageWithSecurityProps = {};
      if (thread.tipType) {
        parsedMessageWithSecurityProps = {
          tip: {
            text: this._getTipMessage(thread.tipType),
            type: thread.tipType,
            value: thread.tipValue,
            visibleTo: thread.tipVisibleTo,
            exhibitionType: 'SECURITY'
          }
        };
      } else if (thread.botType) {
        parsedMessageWithSecurityProps = {
          tip: {
            text: this._getBotMessage(thread.botType),
            type: thread.botType,
            value: thread.botType,
            visibleTo: thread.botVisibleTo,
            exhibitionType: 'ADVICE'
          }
        };
      }
      var parsedTextMasks = this._parseTextMasks(thread.textMasks);
      return _extends({}, parsedMessage, parsedMessageWithSecurityProps, parsedTextMasks);
    }
  }, {
    key: '_parseTextMasks',
    value: function _parseTextMasks(masks) {
      if (masks) {
        try {
          return {
            textMasks: JSON.parse(masks)
          };
        } catch (e) {
          return {};
        }
      }
      return {};
    }
  }, {
    key: '_translateStatus',
    value: function _translateStatus(type, thread) {
      if (type === 'error') {
        return _constants.MessageStatus.ERROR;
      } else if ('readAt' in thread) {
        return _constants.MessageStatus.READ;
      } else if ('receivedAt' in thread) {
        return _constants.MessageStatus.RECEIVED;
      }
      return _constants.MessageStatus.SENT;
    }
  }, {
    key: '_getBotMessage',
    value: function _getBotMessage() {
      var botType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return botTexts[botType] || '';
    }
  }, {
    key: '_getTipMessage',
    value: function _getTipMessage() {
      var tipType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return tipTexts[tipType] || '';
    }
  }, {
    key: 'fromClient',
    value: function fromClient(message) {
      var _message$attrs2 = message.attrs,
        id = _message$attrs2.id,
        roomname = _message$attrs2.to,
        type = _message$attrs2.type;
      var sender = String(this.entity.getUsername());
      var threadText = message.getChildText('thread');
      var thread = threadText ? JSON.parse(threadText) : {};
      var timestamp = (0, _timeDeltaHelper.curTimestamp)();
      var body = message.getChildText('body');
      return {
        id: id,
        roomname: roomname,
        text: body,
        status: type === 'error' ? _constants.MessageStatus.ERROR : _constants.MessageStatus.SENDING,
        timestamp: timestamp,
        originalTimestamp: timestamp,
        sender: sender,
        customType: thread.customType || 'normal',
        notificationData: thread.notificationData || {},
        source: 'real-time',
        extensions: thread.extensions || []
      };
    }
  }]);
  return MessageParser;
}(_plugin2.default);
MessageParser.pluginName = 'messageParser';
exports.default = MessageParser;